import { render, staticRenderFns } from "./MyLoanComponent.vue?vue&type=template&id=0868b40a&"
import script from "./MyLoanComponent.vue?vue&type=script&lang=js&"
export * from "./MyLoanComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports